// src/pages/ContactUs.js
import React from 'react';
import Footer from '../components/Footer';
import './ContactUs.css';

function ContactUs() {
  return (
    <div className="contact-page">
      {/* Banner Section */}
      <div className="contact-banner">
        <div className="contact-banner-overlay"></div>
        <div className="contact-banner-content">
          <h1>Contact Us</h1>
          <p>We're here to help with any questions or ideas you might have.</p>
        </div>
      </div>

      <div className="contact-container">
        {/* Contact Information */}
        <section className="contact-info-section">
          <div className="contact-info-container">
            <div className="contact-info-item">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <div className="contact-details">
                <h3>Email</h3>
                <p><a href="mailto:info@refounded.ca">info@refounded.ca</a></p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <div className="contact-details">
                <h3>Location</h3>
                <p>Ontario, Canada</p>
              </div>
            </div>

            <div className="contact-info-item">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 2.1l4 4-4 4"></path>
                  <path d="M3 12.2v-2a4 4 0 0 1 4-4h12.8M7 21.9l-4-4 4-4"></path>
                  <path d="M21 11.8v2a4 4 0 0 1-4 4H4.2"></path>
                </svg>
              </div>
              <div className="contact-details">
                <h3>Social Media</h3>
                <div className="social-links">
                  <a href="https://www.facebook.com/profile.php?id=100076126100475" target="_blank" rel="noreferrer" title="Facebook">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                    </svg>
                  </a>
                  <a href="https://www.instagram.com/refoundeducation/" target="_blank" rel="noreferrer" title="Instagram">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                    </svg>
                  </a>
                  <a href="https://t.me/+3ZfOun030gszMTEx" target="_blank" rel="noreferrer" title="Telegram">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21.198 2.433a2.242 2.242 0 0 0-1.022.215l-8.609 3.33c-2.068.8-4.133 1.598-5.724 2.21a405.15 405.15 0 0 1-2.849 1.09c-.42.147-.99.332-1.473.901-.728.968.193 1.798.919 2.286 1.61.516 3.275 1.009 4.654 1.472.8 1.917 1.454 3.89 2.193 5.828a1.6 1.6 0 0 0 1.17.867c.686.073 1.273-.312 1.81-.823a1151.73 1151.73 0 0 0 3.891-3.829c.47.235 1.38.705 1.91.95 1.712.73 2.577 1.13 3.527.273.693-.575 1.607-2.686.725-3.683-1.398-1.353-8.188-6.218-9.133-6.917-.295-.204-.633-.287-.968-.237-.332.049-.692.29-.779.262-.18-.043-1.488 1.039-2.62 2.3-.579 1.617-.948 3.29-1.343 4.901-.315 1.605-.585 3.318-1.305 4.755-.53 1.06-2.855 1.476-4.59.78-1.634-.657-2.763-1.413-3.01-1.92-.051-.168-.04-.408.12-.625.181-.253.39-.432.59-.605a35.13 35.13 0 0 1 1.441-1.116c1.842-1.416 3.805-2.495 4.937-3.133.532-.29 1.195-.544 1.47-1.016.468-.571.307-1.387-.269-1.695-.459-.257-.994-.204-1.48-.049l-5.471 2.266c-.43.16-1.488.462-1.969.962-.603.586-.759 1.383-.081 2.234.563.942 1.628 1.608 2.95 1.875 2.312.67 4.1-.018 5.736-1.027.489-.333.934-.718 1.366-1.103.672-.627 1.33-1.292 1.967-1.95.468-.493.997-.991 1.572-1.454.825-.67 1.558-.368 1.805.47.145.5.071 1.063-.49 1.504-3.447 3.421-6.919 6.593-10.303 10.1-.722.752-1.482 1.79-1.12 2.742.345.953 1.638 1.012 2.43.56a1.562 1.562 0 0 0 .571-.361c.613-.539 3.932-3.687 6.149-5.765l-.564 2.366c-.553 2.308-.954 4.635-1.529 6.933-.138.535-.234 1.088-.277 1.638-.064.962.124 1.932.912 2.581.876.798 2.211.998 3.134.192a1.9 1.9 0 0 0 .48-.65c.262-.438.516-.925.69-1.364 1.37-3.636 2.765-7.265 4.153-10.895.545-1.393 1.132-2.78 1.713-4.164a1.59 1.59 0 0 0 .111-.327l.144.456c1.112 3.212 2.185 6.424 3.307 9.645.144.451.314.875.459 1.303.206.664.468 1.293.753 1.932.285.619.57 1.285 1.029 1.845.17.164.38.33.627.383.248.053.56.01.794-.137.37-.232.63-.546.824-.872.195-.33.353-.683.466-1.022.585-1.677 1.13-3.399 1.683-5.092a688.5 688.5 0 0 0 2.645-8.1c.143-.468.254-.931.37-1.437.1-.462.148-.94.116-1.436-.147-1.468-1.646-2.458-3.39-1.663z"></path>
                    </svg>
                  </a>
                  <a href="https://www.youtube.com/@refoundeducation" target="_blank" rel="noreferrer" title="YouTube">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
                      <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Calendly Section */}
        <section className="contact-form-section">
          <div className="contact-form-container">
            <h2>Schedule a Meeting</h2>
            <p>Have questions or want to learn more about our services? Schedule a 30-minute meeting with our team.</p>
            
            <div className="calendly-container">
              <div className="calendly-info">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="calendly-icon">
                  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                  <line x1="16" y1="2" x2="16" y2="6"></line>
                  <line x1="8" y1="2" x2="8" y2="6"></line>
                  <line x1="3" y1="10" x2="21" y2="10"></line>
                </svg>
                <div className="calendly-text">
                  <h3>30-Minute Consultation</h3>
                  <p>Select a convenient time for a quick discussion about how we can help you.</p>
                </div>
              </div>
              <a 
                href="https://calendly.com/refounded/30min" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="calendly-button"
              >
                Schedule Meeting
              </a>
            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="map-section">
          <div className="map-container">
            <h2>Find Us</h2>
            <div className="map-embed">
              <iframe 
                title="RefoundEd Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5778937.360259787!2d-84.96423084450574!3d46.32488986598316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cce05b25f5113af%3A0x70f8425629621e09!2sOntario%2C%20Canada!5e0!3m2!1sen!2sus!4v1711321326797!5m2!1sen!2sus" 
                width="600" 
                height="450" 
                style={{ border: 0 }} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </section>
      </div>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="faq-container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>What is RefoundEd?</h3>
              <p>RefoundEd is a platform that empowers educators and decentralizes education by supporting grassroots initiatives. It helps families across Canada access educational and recreational opportunities.</p>
            </div>
            <div className="faq-item">
              <h3>How can I become a service provider?</h3>
              <p>To become a service provider, sign in to your account and click on "Become a Provider" in the navigation menu. Fill out the application form, and our team will review your submission.</p>
            </div>
            <div className="faq-item">
              <h3>How do I list my educational services?</h3>
              <p>Once approved as a service provider, you can add listings by clicking on "Add Listing" in the navigation menu. Fill in the details about your service, and it will be published on our platform.</p>
            </div>
            <div className="faq-item">
              <h3>Is RefoundEd available across all of Canada?</h3>
              <p>Yes, RefoundEd serves families and educators across Canada, with a growing presence in Ontario and expanding to other provinces.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default ContactUs;